import React from 'react'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'
import {htmlToText, IMailTemplateModel} from './MailTemplateModel'

type Props = {
  data: IMailTemplateModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit: (template: IMailTemplateModel) => void
  onDelete: (template: IMailTemplateModel) => void
  loading?: boolean
}

export const MailTemplateTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<IMailTemplateModel>[] = [
    {
      key: 'name',
      label: 'Şablon',
      render: (_, template) => (
        <div className='d-flex flex-column'>
          <span className='fw-semibold'>{template.name}</span>
          {template.description && (
            <span className='text-muted fs-7'>{template.description}</span>
          )}
        </div>
      ),
    },
    {
      key: 'subject',
      label: 'Konu',
      render: (subject: string, template) => (
        <div className='d-flex flex-column'>
          <span>{subject}</span>
          <span className='text-muted fs-8 text-truncate' style={{maxWidth: 420}}>
            {htmlToText(template.body || '')}
          </span>
        </div>
      ),
    },
    {
      key: 'active',
      label: 'Durum',
      width: '110px',
      render: (active: boolean) =>
        active !== false ? (
          <span className='badge badge-light-success'>Aktif</span>
        ) : (
          <span className='badge badge-light-danger'>Pasif</span>
        ),
    },
  ]

  const actions: TableAction<IMailTemplateModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: onEdit,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz mail şablonu bulunamadı'
    />
  )
}
